import styled from "@emotion/styled";

export const AdminManageSettingsWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	a: {
		textDecoration: "none",
		cursor: "pointer",
		padding: 16,
		border: theme.project.borders.presets.outline,
		borderWidth: "1px",
		backgroundColor: theme.project.colors.backgroundColors.main,
		position: "relative",
		color: theme.project.colors.fontColors.main,
		display: "inline-flex",
		flexDirection: "column",
		gap: "8px",
		"&:hover": {
			backgroundColor: theme.project.colors.backgroundColors["card:hover"]
		},
		h2: {
			...theme.project.typography.heading.h6,
			margin: 0
		},
		span: {
			color: theme.project.colors.fontColors.secondary,
			fontStyle: "italic",
			letterSpacing: "0.17px",
			margin: "0px",
			lineHeight: "143%"
		},
		svg: {
			position: "absolute",
			right: "16px",
			top: "50%",
			transform: "translateY(-50%)"
		},
		[theme.breakpoints.down("lg")]: {
			padding: 16
		}
	}
}));
